import { LookupKeys } from 'ag-common-lib/lib/models/crm/lookup.model';

export enum ButtonStylingMode {
  contained = 'contained',
  outlined = 'outlined',
  text = 'text',
}

export const ButtonStylingModeMap = new Map([
  [ButtonStylingMode.contained, 'Contained'],
  [ButtonStylingMode.outlined, 'Outlined'],
  [ButtonStylingMode.text, 'Text'],
]);

export const BUTTON_STYLING_MODE_LOOKUP = [
  ButtonStylingMode.contained,
  ButtonStylingMode.outlined,
  ButtonStylingMode.text,
].map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: ButtonStylingModeMap.get(value) };
});
